<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        <span>为什么选择星汉未来</span>
        <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />
        <span>成本优化解决方案?</span>
      </a-typography-title>
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="6">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalOperate','reserve')">
          预约演示
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_why',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '成本全景可视化',
            text: '从云平台、云产品、业务线、应用等多维度分析并展示成本现状，高效洞察成本问题。'
          },
          {
            title: '成本精细化拆分',
            text: '将成本精细化拆分到具体应用，快速精准定位资源消耗最多的业务，明确优化方向。'
          },
          {
            title: '多维度优化手段',
            text: '提供服务器层、容器层、业务层等多个维度的成本优化功能，轻松达成优化目标。'
          },
          {
            title: '定制化优化方案',
            text: '基于成本洞察结果，为企业量身定制高效优化方案，实现体系化且有针对性的成本优化。'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planCost/';

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 60px;
  position: relative;
  padding: 30px;
  background: @color_white;
  border-radius: 8px;
  .shadow(0 0 15px fade(@color_black, 10));
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    width: @wh;
    height: @wh;
    margin: 0 auto;
    .bg('@{image}why_icon.png', @wh*4, @wh);
  }
  
  h5.ant-typography {
    margin: 20px 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    min-height: 78px;
    margin: 20px 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    padding: 20px;
    
    h5.ant-typography {
      margin: @margin_mo 0 0;
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>